/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Accordion_Offertype1Inputs */

const id_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Penawaran`)
};

const ms_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Tawaran`)
};

const da_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbudstype`)
};

const de_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebotstyp`)
};

const en_us2_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer Type`)
};

const es_es2_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de oferta de catálogo`)
};

const es_mx2_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de oferta`)
};

const fil_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uri ng Offer`)
};

const fr_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type d'offre`)
};

const it_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo offerta`)
};

const hu_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlat típusa`)
};

const nl_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbodtype`)
};

const no_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbudstype`)
};

const pl_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ oferty`)
};

const pt_br2_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de oferta de catálogo`)
};

const pt_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de oferta`)
};

const ro_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip ofertă`)
};

const fi_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjouksen tyyppi`)
};

const sv_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudandetyp`)
};

const vi_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại ưu đãi`)
};

const tr_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif Türü`)
};

const cs_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ nabídky`)
};

const bg_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип оферта`)
};

const ru_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип предложения`)
};

const uk_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип пропозиції`)
};

const ar_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع العرض`)
};

const hi_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र प्रकार`)
};

const th_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประเภทข้อเสนอ`)
};

const ja_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファータイプ`)
};

const zh_cn2_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录项类型`)
};

const zh_hant1_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄項目類型`)
};

const ko_search_accordion_offertype1 = /** @type {(inputs: Search_Accordion_Offertype1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼 유형`)
};

/**
* | output |
* | --- |
* | "Offer Type" |
*
* @param {Search_Accordion_Offertype1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_accordion_offertype1 = /** @type {((inputs?: Search_Accordion_Offertype1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Accordion_Offertype1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_accordion_offertype1(inputs)
	if (locale === "ms") return ms_search_accordion_offertype1(inputs)
	if (locale === "da") return da_search_accordion_offertype1(inputs)
	if (locale === "de") return de_search_accordion_offertype1(inputs)
	if (locale === "en-US") return en_us2_search_accordion_offertype1(inputs)
	if (locale === "es-ES") return es_es2_search_accordion_offertype1(inputs)
	if (locale === "es-MX") return es_mx2_search_accordion_offertype1(inputs)
	if (locale === "fil") return fil_search_accordion_offertype1(inputs)
	if (locale === "fr") return fr_search_accordion_offertype1(inputs)
	if (locale === "it") return it_search_accordion_offertype1(inputs)
	if (locale === "hu") return hu_search_accordion_offertype1(inputs)
	if (locale === "nl") return nl_search_accordion_offertype1(inputs)
	if (locale === "no") return no_search_accordion_offertype1(inputs)
	if (locale === "pl") return pl_search_accordion_offertype1(inputs)
	if (locale === "pt-BR") return pt_br2_search_accordion_offertype1(inputs)
	if (locale === "pt") return pt_search_accordion_offertype1(inputs)
	if (locale === "ro") return ro_search_accordion_offertype1(inputs)
	if (locale === "fi") return fi_search_accordion_offertype1(inputs)
	if (locale === "sv") return sv_search_accordion_offertype1(inputs)
	if (locale === "vi") return vi_search_accordion_offertype1(inputs)
	if (locale === "tr") return tr_search_accordion_offertype1(inputs)
	if (locale === "cs") return cs_search_accordion_offertype1(inputs)
	if (locale === "bg") return bg_search_accordion_offertype1(inputs)
	if (locale === "ru") return ru_search_accordion_offertype1(inputs)
	if (locale === "uk") return uk_search_accordion_offertype1(inputs)
	if (locale === "ar") return ar_search_accordion_offertype1(inputs)
	if (locale === "hi") return hi_search_accordion_offertype1(inputs)
	if (locale === "th") return th_search_accordion_offertype1(inputs)
	if (locale === "ja") return ja_search_accordion_offertype1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_accordion_offertype1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_accordion_offertype1(inputs)
	return ko_search_accordion_offertype1(inputs)
});
export { search_accordion_offertype1 as "search.accordion.offerType" }